<template>
    <div>
        <div class="truncate pt-5 pb-3 px-0 mb-5 border-b border-[#CFD9DE]">
            <div class="flex justify-between px-5">
                <div class="text-base font-medium text-gray-800 shimmer w-full h-4"></div>
                <div class="text-sm font-medium text-gray-800 shimmer w-full h-4"></div>
            </div>
        </div>
        <div class="px-5">
            <div>
                <div class="text-2xl font-semibold text-gray-900 mb-3 h-12 w-full shimmer"></div>
            </div>
        </div>
        <div class="px-5 pt-5 pb-10">
            <div class="flex justify-between items-center">
                <div class="top-recommended-card-image w-1/3 pr-5">
                    <div class="text-2xl font-semibold text-gray-900 mb-3">
                        <div class="h-36 w-full shimmer"></div>
                    </div>
                </div>
                <div class="top-recommended-card-details w-2/3 pl-5">
                    <div class="mb-5 pr-10">
                        <div class="mb-3 h-24 shimmer"></div>
                    </div>
                    <div class="flex justify-between">
                        <div>
                            <div class="text-xs h-4 w-40 shimmer"></div>
                        </div>
                        <div>
                            <div class="h-4 w-40 shimmer"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss"></style>
